// extracted by mini-css-extract-plugin
export default {"dataInputSwitcherContainer":"IOCheckInPageDataInputSwitcher-module__dataInputSwitcherContainer--vF4pR"};